import api from './api';

const mailManagementService = {
  /**
   * Get mail history list for the grid. Filter by submodule and optionally by project (session project).
   * @param {string} [subModuleName] - "Visit Letter" or "PI Confirmation"
   * @param {string} [projectCode] - Session project code; when provided, only mail for visits in that project is returned
   * @returns {Promise<Array>} List of mail records
   */
  async getList(subModuleName = null, projectCode = null) {
    const params = {};
    if (subModuleName) params.subModuleName = subModuleName;
    if (projectCode) params.projectCode = projectCode;
    const response = await api.get('/mail-management', { params });
    return response.data || [];
  },

  /**
   * Get stored raw email content (HTML) for a mail record by nMailManagementMstNo for "View" action.
   * @param {number} mailRecordId - nMailManagementMstNo
   * @returns {Promise<{ rawMailContent?: string | null }>}
   */
  async getMailContent(mailRecordId) {
    const response = await api.get(`/mail-management/${mailRecordId}/content`);
    const d = response.data;
    return {
      rawMailContent: d?.rawMailContent ?? d?.RawMailContent ?? null,
    };
  },

  /**
   * Resend the visit letter email for this mail record. Backend records the new attempt.
   * @param {number} id - nMailManagementMstNo
   * @returns {Promise<{ message: string }>}
   */
  async resend(id) {
    const response = await api.post(`/mail-management/${id}/resend`);
    return response.data;
  },
};

export default mailManagementService;
